import React, {useState} from "react";
import {Box, Heading, Pagination, Table} from "react-bulma-components";
import {useFittersData} from "../../../hooks/useFittersData";
import {useDispatch, useSelector} from "react-redux";
import {getDataFresh, getFittersData} from "../../../state/selectors";
import NewFitter from "./NewFitter";
import FitterRow from "./FitterRow";
import Spinner from "react-spinner-material";
import mapDispatchToProps from "react-redux/lib/connect/mapDispatchToProps";
import {createSetDataFreshAction, createSetFittersDataAction} from "../../../actions/dataActions";
import axios from "axios";
import {NotificationManager} from "react-notifications";



function FitterView(props){
    const dispatch = useDispatch();
    let dataFresh = useSelector(getDataFresh);
    const [page, setPage] = useState(1);
    const loading = useFittersData({page, show_hide: true},dataFresh);
    const data = useSelector(getFittersData);

    if (!loading) {
        return (
        <Box>
            <Spinner
                className="spinner-centre"
                size={120}
                spinnerColor={"#3273dc"}
                spinnerWidth={2}
            />
        </Box>
        );
    }

    const onChange = (e, index) => {
        let newFitter = data.results[index]
        newFitter[e.target.name] = e.target.value;
        data.results[index] = newFitter
        dispatch(createSetFittersDataAction(data.results));
    }

    const onSave = (setEditable, fitter) => {
        const conf = {
            url: 'api/fitter/'+ fitter.id,
            method: "put",
            data: fitter
        }
        axios(conf).then(res => {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            setEditable(false);
        }).catch(err => {
            NotificationManager.error("There was an error")
        })
    }

    return (
        <div>
            <br/>
            <NewFitter/>
            <Box>
                <Heading>Fitters</Heading>
                <Table size={"fullwidth"}>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Hide</th>
                            <th></th>
                        </tr>
                    </thead>
                    {data.results.map((value,index) => (
                         <FitterRow
                             fitter={value}
                             onChange={onChange}
                             index={index}
                             onSave={onSave}
                         />
                    ))}
                </Table>
                <Pagination
                  showFirstLast={true}
                  onChange={page => setPage(page)}
                  current={page}
                  total={Math.ceil(data.count / 25)}
                />
            </Box>
        </div>
    )

}
export default FitterView;